import {createContext} from "react";

const ConfirmDialogContext = createContext(null);

export default ConfirmDialogContext;